module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./CoinView.js"));
	}, "CoinView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CoinView!./src/pages/Shop/Member/Wallet/Coin/CoinView.js
// module id = 1048
// module chunks = 438